import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../context/AuthContext';
import type { UserRole } from '../services/authService';

interface RoleRouteProps {
  allowedRoles: UserRole[];
  children: React.ReactNode;
}

const RoleRoute = ({ allowedRoles, children }: RoleRouteProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (!user || !allowedRoles.includes(user.role)) {
    return (
      <Navigate
        to={user?.role === 'admin' ? '/admin' : '/dashboard'}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default RoleRoute;
